import React from 'react';
import { RotateCw } from 'lucide-react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import ErrorPage from '../../Common/ErrorPages';

const CLSFIServerError = ({ onRetry }) => (
  <ErrorPage
    Header={Header}
    Footer={Footer}
    brandAttr="CLS"
    code="500"
    title="Jotain meni pieleen"
    description="Tapahtui odottamaton virhe. Yritä uudelleen tai palaa etusivulle."
    primaryCta={{
      label: 'Yritä uudelleen',
      onClick: onRetry || (() => window.location.reload()),
      icon: <RotateCw size={20} />,
    }}
    secondaryCta={{ label: 'Etusivulle', to: '/clothing/cls-fi' }}
  />
);

export default CLSFIServerError;
